import React from "react"

const CustomPopover = ({ title, description, list }) => {
  const renderList = () => {
    return list.map((item, index) => {
      return (
        <li key={index} className="text-sm text-left">
          {item}
        </li>
      )
    })
  }

  return (
    <div className="flex flex-col gap-3 justify-start items-start max-w-[216px] px-3 py-6 bg-white shadow-popover border border-gray-400 rounded-xl">
      <p className=" text-sm font-bold text-left">{title}</p>
      <div className="flex flex-col gap-5 justify-start items-start">
        <p className="text-sm text-left">{description}</p>
        <ul className="list-disc list-outside ml-4">{list && renderList()}</ul>
      </div>
    </div>
  )
}

export default CustomPopover
